// Shared "modern pixel game" UI primitives — Powerpuff Girls palette,
// stepped pixel corners, hard offset shadows instead of blur.
import styled, { css } from 'styled-components'

// A stair-stepped rectangle clip-path that reads as a pixel-art panel
// corner instead of a rounded one. `n` is the notch size in px.
export const pixelCorners = (n = 8) => css`
  clip-path: polygon(
    0 ${n}px, ${n}px ${n}px, ${n}px 0,
    calc(100% - ${n}px) 0, calc(100% - ${n}px) ${n}px, 100% ${n}px,
    100% calc(100% - ${n}px), calc(100% - ${n}px) calc(100% - ${n}px), calc(100% - ${n}px) 100%,
    ${n}px 100%, ${n}px calc(100% - ${n}px), 0 calc(100% - ${n}px)
  );
`

// Solid, hard-edged "game UI" drop shadow (no blur) in the ink color.
export const pixelShadow = (x = 6, y = 6, color) => css`
  box-shadow: ${x}px ${y}px 0 0 ${(props) => color || props.theme.black};
`

export const PixelPanel = styled.div`
  position: relative;
  background: ${(props) => props.$bg || props.theme.panel};
  border: 4px solid ${(props) => props.theme.black};
  ${pixelCorners(10)}
  ${(props) => pixelShadow(8, 8)}
`

export const PixelButton = styled.button`
  font-family: ${(props) => props.theme.pixelFont};
  font-size: 0.85rem;
  color: ${(props) => props.theme.black};
  background: ${(props) => props.$bg || props.theme.yellow};
  border: 4px solid ${(props) => props.theme.black};
  padding: 0.9rem 1.4rem;
  cursor: pointer;
  ${pixelCorners(6)}
  ${(props) => pixelShadow(5, 5)}
  transition: transform 0.08s ease, box-shadow 0.08s ease;

  &:hover {
    transform: translate(-2px, -2px);
    ${(props) => pixelShadow(7, 7)}
  }

  &:active {
    transform: translate(3px, 3px);
    box-shadow: 2px 2px 0 0 ${(props) => props.theme.black};
  }
`

export const PixelTag = styled.span`
  display: inline-block;
  font-family: ${(props) => props.theme.pixelFont};
  font-size: 0.55rem;
  letter-spacing: 0.02em;
  background: ${(props) => props.$bg || props.theme.lavender};
  color: ${(props) => props.theme.black};
  border: 2px solid ${(props) => props.theme.black};
  padding: 0.35rem 0.5rem;
  margin: 0 0.4rem 0.4rem 0;
`
